export default {
  floorplans: [],
};
